import { useContext } from 'react';
import { func, any } from 'prop-types';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import ApplicationContext from 'components/Application/Context';
import { getDefaultLocation } from 'utils/auth';

function RoutePublic({
  element: Component,
  getLocation,
  externalContext,
  ...restProps
}) {
  const { user, permissions, token } = useContext(ApplicationContext);

  const location = useLocation();
  const { ...props } = useParams();
  // Not authenticated
  if (!token || !permissions || !user) {
    return <Component {...restProps} {...props} location={location} />;
  }

  const { redirectOnAuthenticated, from } = location.state || {};
  const redirectTo = redirectOnAuthenticated ? from : getLocation(user);

  return <Navigate to={redirectTo} />;
}

RoutePublic.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  element: any.isRequired,
  getLocation: func,
};

RoutePublic.defaultProps = {
  getLocation: getDefaultLocation,
  externalContext: false,
};

export default RoutePublic;
